import { CONF } from '../constants';

/**
 *
 * @param {any} data
 * @param {object} filters
 * @param {boolean} sort
 * @returns
 */
export function processResponse(response = {}, filters, sort, ignoreId = false) {
  const { config, data = {} } = response;
  // eslint-disable-next-line prefer-const
  let { data: nestedData, total } = data;
  const [resource] = (config?.url || '').split('?');

  let values;

  if (resource === '/private/orders/client_filter') {
    values = nestedData?.rows || [];
  } else {
    values = nestedData || [];
  }

  if (values === null || values === undefined) {
    values = [];
  }

  if (typeof values === 'string') {
    try {
      values = JSON.parse(values);
    } catch (e) {
      values = [];
    }
  }

  const {
    getById = true,
    sort: defaultSort,
  } = CONF[resource] || {};

  if ('id' in filters && getById && !ignoreId) {
    [values] = values;

    return values;
  }

  const sortCriteria = sort || defaultSort;
  if (sortCriteria) {
    values.sort((a, b) => a[sortCriteria] - b[sortCriteria]);
  }

  if (!total) {
    total = 0;
  }

  return {
    values,
    total,
  };
}
